import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function ProtectedRoute({ children, requireAdmin = false, redirectTo = "/auth" }) {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();
  const language = (() => {
    try {
      const value = window.localStorage.getItem("colobongo_language");
      return value === '"en"' || value === "en" ? "en" : "fr";
    } catch (_error) {
      return "fr";
    }
  })();

  if (loading) {
    return (
      <div className="page-content px-4 pt-6 pb-24 max-w-md mx-auto">
        <div className="cozy-card p-5 rounded-2xl">
          <p className="text-sm text-[color:var(--cb-text-muted)]">
            {language === "fr" ? "Vérification de sécurité..." : "Security check..."}
          </p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={redirectTo} replace state={{ from: location.pathname }} />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/studio" replace state={{ denied: "admin" }} />;
  }

  return children;
}
